import { render, staticRenderFns } from "./HeaderV2Organism.vue?vue&type=template&id=db600a18&scoped=true&"
import script from "./HeaderV2Organism.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2Organism.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2Organism.vue?vue&type=style&index=0&id=db600a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db600a18",
  null
  
)

export default component.exports